import React from 'react';
import { motion } from 'framer-motion';
import { Twitter, Linkedin, Star, Quote } from 'lucide-react';

// DATOS FALSOS PERO REALISTAS
const reviews = [
  {
    name: "Alex Dev",
    handle: "@alex_frontend",
    role: "Junior en Google",
    text: "Conseguí mi primer trabajo en 3 meses. La ruta de React es oro puro. 🚀",
    platform: "twitter",
    image: "https://randomuser.me/api/portraits/men/32.jpg"
  },
  {
    name: "Sarah Code",
    handle: "@sarah_js",
    role: "Freelancer",
    text: "La comunidad de Discord vale más que la suscripción. Siempre hay alguien ayudando.",
    platform: "linkedin",
    image: "https://randomuser.me/api/portraits/women/44.jpg"
  },
  {
    name: "Miguel Ángel",
    handle: "@miguel_tech",
    role: "CTO Startup",
    text: "Uso Zento para entrenar a mis nuevos devs. Me ahorra cientos de horas de mentoring.",
    platform: "twitter",
    image: "https://randomuser.me/api/portraits/men/86.jpg"
  },
  {
    name: "Laura V.",
    handle: "@laura_ui",
    role: "UX Engineer",
    text: "El diseño de la plataforma es increíble, pero el contenido es aún mejor. 10/10.",
    platform: "linkedin",
    image: "https://randomuser.me/api/portraits/women/65.jpg"
  },
  {
    name: "Javi Script",
    handle: "@javiscript",
    role: "FullStack Dev",
    text: "Pasé de tutorial hell a construir apps reales. El proyecto de Airbnb clone fue clave.",
    platform: "twitter",
    image: "https://randomuser.me/api/portraits/men/11.jpg"
  },
  {
    name: "Elena N.",
    handle: "@elena_noob",
    role: "Estudiante",
    text: "No sabía nada de programación. Hoy desplegué mi primera API. Estoy llorando 😭❤️",
    platform: "twitter",
    image: "https://randomuser.me/api/portraits/women/33.jpg"
  }
];


const ReviewCard = ({ review }) => (
  <div className="flex-shrink-0 w-[350px] p-6 rounded-2xl bg-white dark:bg-[#111] border border-slate-200 dark:border-white/10 shadow-sm mx-4 relative group hover:border-blue-500/30 transition-colors">
    
    
    <div className="absolute top-4 right-4 text-slate-200 dark:text-white/5">
      <Quote className="w-8 h-8 fill-current" />
    </div>

    <div className="flex items-center gap-4 mb-4">
      <img src={review.image} alt={review.name} className="w-10 h-10 rounded-full border border-slate-200 dark:border-white/10" />
      <div>
        <div className="flex items-center gap-1">
           <h4 className="text-sm font-bold text-slate-900 dark:text-white">{review.name}</h4>
           
           {review.platform === 'twitter' ? <Twitter className="w-3 h-3 text-blue-400 fill-blue-400" /> : <Linkedin className="w-3 h-3 text-blue-600 fill-blue-600" />}
        </div>
        <p className="text-xs text-slate-500 dark:text-gray-500">{review.handle}</p>
      </div>
    </div>
    
    <p className="text-sm text-slate-600 dark:text-gray-300 leading-relaxed">
      {review.text}
    </p>

    <div className="mt-4 flex items-center gap-2 pt-4 border-t border-slate-100 dark:border-white/5">
       <span className="text-xs font-bold text-slate-400 uppercase tracking-wider">{review.role}</span>
       <div className="flex ml-auto text-yellow-500 gap-0.5">
          {[1,2,3,4,5].map(i => <Star key={i} className="w-3 h-3 fill-current" />)}
       </div>
    </div>
  </div>
);


const InfiniteMarquee = ({ children, direction = "left" }) => {
  return (
    <div className="relative flex overflow-hidden w-full py-4 mask-gradient">
      <motion.div
        className="flex"
        animate={{ x: direction === "left" ? ["0%", "-50%"] : ["-50%", "0%"] }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: 40, 
            ease: "linear",
          },
        }}
        style={{ width: "fit-content" }} 
      >
        {children}
        {children} 
      </motion.div>
      
      
      <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-slate-50 dark:from-[#0a0a0a] to-transparent z-10"></div>
      <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-slate-50 dark:from-[#0a0a0a] to-transparent z-10"></div>
    </div>
  );
};


const CompanyLogos = () => (
  <div className="flex flex-wrap justify-center gap-8 md:gap-16 opacity-50 grayscale hover:grayscale-0 transition-all duration-500">
     
     <svg className="h-6 md:h-8 w-auto fill-slate-800 dark:fill-white" viewBox="0 0 23 23"><path d="M0 0h11v11H0zM12 0h11v11H12zM0 12h11v11H0zM12 12h11v11H12z"/></svg>
     
     
     <svg className="h-6 md:h-8 w-auto fill-slate-800 dark:fill-white" viewBox="0 0 24 24"><path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z"/></svg>
     
     
     <svg className="h-6 md:h-8 w-auto fill-slate-800 dark:fill-white" viewBox="0 0 24 24"><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.48.66.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/></svg>
     
     
     <svg className="h-6 md:h-8 w-auto fill-slate-800 dark:fill-white" viewBox="0 0 24 24"><path d="M12.02.09c-.58.05-1.26.23-1.63.78L.68 12.84c-.88 1.13-.13 2.92 1.3 2.89h3.76v7.35c0 .6.47 1.08 1.05 1.08h4.22V17.1h2.15v7.06h4.15c.58 0 1.05-.48 1.05-1.08v-7.35h3.69c1.43.03 2.18-1.76 1.3-2.89L13.65.87c-.37-.55-1.05-.73-1.63-.78z"/></svg>
  </div>
);


const Testimonials = () => {
  return (
    <section className="py-24 bg-slate-50 dark:bg-[#0a0a0a] border-t border-slate-200 dark:border-white/5 transition-colors duration-500 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-16 text-center">
        
        
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-100 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 text-xs font-bold uppercase tracking-wider mb-6">
          <Star className="w-3 h-3 fill-current" />
          Wall of Love
        </div>

        <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 dark:text-white mb-6">
          Nuestros alumnos ahora <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-500">
            trabajan en las mejores empresas.
          </span>
        </h2>
        
        
        <div className="mt-12 mb-12">
           <CompanyLogos />
        </div>
      </div>

      
      <InfiniteMarquee direction="left">
        {reviews.map((review, i) => (
           <ReviewCard key={`l-${i}`} review={review} />
        ))}
      </InfiniteMarquee>
      
      
      <div className="mt-6">
        <InfiniteMarquee direction="right">
          {reviews.reverse().map((review, i) => (
             <ReviewCard key={`r-${i}`} review={review} />
          ))}
        </InfiniteMarquee>
      </div>

    </section>
  );
};

export default Testimonials;